import { DateInput } from "components/DesignSystem/DateInput/DateInput";
import { YYYY_MM_DD } from "constants/date";
import dayjs from "dayjs";
import { Field, FieldProps, Form, Formik } from "formik";
import { useToast } from "hooks/useToast";
import { useUpdateTaskAssigneeAdminMutation } from "store/apis/serviceTeam";
import { Task1120Tracker } from "types/Models/TaskTracker";

export const PreparationCompletedOnColumn = ({
  row,
}: {
  row: Task1120Tracker;
}) => {
  const [updateTaskAssignee] = useUpdateTaskAssigneeAdminMutation();
  const { alertToast, successToast } = useToast();

  const handleDateChange = async (date: Date) => {
    try {
      await updateTaskAssignee({
        taskId: row.task_uuid,
        preparation_complete_date: dayjs(date).format(YYYY_MM_DD),
      }).unwrap();
      successToast({ message: "Preparation completed date updated" });
    } catch (error: any) {
      alertToast({ message: error?.data?.error?.message });
    }
  };

  const taskId = row.task_uuid;

  return (
    <Formik
      onSubmit={() => {}}
      initialValues={{
        preparation_complete_date: row.preparation_complete_date,
      }}
    >
      {({ setFieldValue }) => (
        <Form className="t-w-full t-m-0" onClick={(e) => e.stopPropagation()}>
          <Field name="preparation_complete_date">
            {({ field }: FieldProps) => (
              <DateInput
                {...field}
                portalId={"preparation_complete_date_portal" + taskId}
                onDateChange={(date) => {
                  setFieldValue("preparation_complete_date", date);
                  handleDateChange(date);
                }}
              />
            )}
          </Field>
        </Form>
      )}
    </Formik>
  );
};
